<template>
    <div>
          <Upload   
              ref="myUpload"
              :action="uploadUrl"
              name="file" 
              :on-success="handleSuccess" 
              :max-size="maxSize"
              :on-remove='handleRemove'
              :on-exceeded-size="handleMaxSize"
              :show-upload-list="showUploadList"
              :before-upload="handleBeforeUpload"
              :multiple = "multiple"
             >
                <Button  icon="ios-cloud-upload-outline" v-if="uploadShow">{{buttonText}}</Button>
            </Upload> 
             <div>
                <div v-for="(item, index) in uploadFileList" :key="index">
                    <div v-if="isImg(item)" style="float:left;margin:10px;">
                        <img  :src="`${item.url}`"  width="100">
                    </div>
                    <div v-else-if="isVideo(item.url)" style="float:left;margin:10px;">
                      <video controls="controls"  :src="`${item.url}`"  width="100" height="100">您的浏览器不支持该视频标签</video>;
                    </div>
                    <div v-else style="float:left;margin:10px;">
                      <a :href="`${item.url}`" target="_blank">
                      {{item.name}}
                      </a>
                    </div>
                </div>
            </div>
             <Modal id="imgModal"   v-model="uploadModal">
                <img v-if="imgUrl" :src="`${fileUrl}/${imgUrl}`" 
                width="100%"
                height="100%">
            </Modal>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        buttonText: '图表上传',
        imgUrl:false,
        fileUrl:'',
        uploadFileList:[],
        uploadUrl:'',
        uploadModal:false,
        port:'',
        uploadShow: true,
        multiple : false,
        maxSize : 1024*4,
        showUploadList: true,
      }
    },
     mounted () {
         
         
          //设置上传图片路径
          this.uploadUrl =  window.g.ApiUrl + "api/upload_img"
        
        
    },
    methods: {
      viewImg(item){
          this.uploadModal = true
          this.imgUrl = item
      },
      isImg(item){
          if(/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(item.url))
          {
            return true;
          }else {
            return false;
          }
      },
      isVideo(item){
          if(/\.(mp4|avi)$/.test(item.url)){
             return true;
          }else{
            return false;
          }
      },
      handleSuccess(res, file) {
          this.uploadFileList.push({ url : res.data});
      },
      handleRemove(file) {
         this.uploadFileList.splice(this.uploadFileList.indexOf(file), 1)
      },
      handleMaxSize (file) {
          this.$Notice.warning({
              title: '上传文件大小超出限制提示',
              desc: '文件  ' + file.name + ' 太大, 不能超过4M.'
          });
      },
      handleBeforeUpload(){
          return true;
      },
      handleClearFiles () {
        // 子组件预定义清除upload方法
        this.$refs.myUpload.clearFiles()
      }
    },
  }
</script>
<style>
    #imgModal .ivu-modal-body{
      padding: 0;
    }
    #imgModal .ivu-modal-footer{
      display: none;
    }


</style>


// WEBPACK FOOTER //
// src/components/upload/ZgUpload.vue